import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoFiltros, IndicacaoIndicados } from './indicacao.types';

export const getIndicacaoIndicados = async (filtros?: IndicacaoFiltros) => {
	try {
		const response = await BaseClient.get<IndicacaoApiResponse<IndicacaoIndicados>>(
			'v2/Indicacao/Lista/Indicados',
			{
				params: {
					data_inicio: filtros?.data_inicio || undefined,
					data_fim: filtros?.data_fim || undefined,
					id_usuario: filtros?.id_usuario || undefined,
				},
			}
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoIndicados>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
